import SiafLiteApiRepository from "../../external/siafLiteApi";
import store from "../../config/store";
import { SiafLiteApiStream } from "../../external";

class OrcamentosService {
  constructor() {
    this.urlBase = "/faturamento/orcamentos";
    this.urlBaseEvent = `/event${this.urlBase}`;
    this.urlBaseCompleta = `${store.baseUrl}${this.urlBase}`;
  }

  cadastrar(body) {
    return new SiafLiteApiRepository(this.urlBaseEvent).post(body);
  }

  getAll(filter) {
    return new SiafLiteApiRepository(this.urlBaseEvent).get(filter);
  }

  deletar(id) {
    return new SiafLiteApiRepository(this.urlBaseEvent).delete(id);
  }

  getById(id) {
    return new SiafLiteApiRepository(this.urlBaseEvent).getById(id);
  }

  atualizar(id, body) {
    return new SiafLiteApiRepository(this.urlBaseEvent).put(id, body);
  }

  getAllFiltroAvancado(body) {
    return new SiafLiteApiRepository(this.urlBaseEvent).patch(body);
  }

  relatorioResumido(body) {
    return new SiafLiteApiStream(
      `${this.urlBaseCompleta}/relatorios/resumido`
    ).path(body);
  }

  pdf(body) {
    return new SiafLiteApiRepository(`${this.urlBaseEvent}/pdf`).post(body);
  }

  pdfSecundario(body) {
    return new SiafLiteApiRepository(
      `${this.urlBaseEvent}/pdf-secundario`
    ).post(body);
  }

  cancelar(id) {
    return new SiafLiteApiRepository(
      `${this.urlBaseEvent}/${id}/cancelar`
    ).get();
  }
}

export default OrcamentosService;
